import { createAction } from 'redux-act';

export const test = createAction('test');
